
import { mapGetters } from 'vuex';

export default {
  i18nComponentKey: 'ReviewsEditLegacy.components.AddMediaPopup',
  name: 'AddMediaPopup',
  computed: {
    ...mapGetters('reviewSettings', ['isVideoUploadable'])
  }
};
